import React, { useState } from 'react';
import './BasicAuthModal.css';

const BasicAuthModal = ({ onAuthenticated }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Default credentials (can be moved to env vars later)
    const correctUsername = 'admin';
    const correctPassword = 'Asdfg1maj*';

    if (username === correctUsername && password === correctPassword) {
      // Store auth token in sessionStorage (expires when browser closes)
      sessionStorage.setItem('basicAuthToken', btoa(`${username}:${password}`));
      onAuthenticated();
    } else {
      setError('Invalid username or password');
      setLoading(false);
    }
  };

  return (
    <div className="basic-auth-overlay">
      <div className="basic-auth-modal">
        <div className="auth-header">
          <h2>🔐 Authentication Required</h2>
          <p>Please enter your credentials to access GuiltBox</p>
        </div>
        
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="username">Username:</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              required
              autoComplete="username"
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              autoComplete="current-password"
            />
          </div>
          
          {error && (
            <div className="auth-error">
              ❌ {error}
            </div>
          )}
          
          <button 
            type="submit" 
            className="auth-submit"
            disabled={loading}
          >
            {loading ? '🔄 Authenticating...' : '🚀 Login'}
          </button>
        </form>
        
        <div className="auth-footer">
          <small>Session expires when browser is closed</small>
        </div>
      </div>
    </div>
  );
};

export default BasicAuthModal;